import React, { useEffect, useState } from 'react';
import { func, object, string } from 'prop-types';
import HrbTranslate from '../../../components/language/HrbTranslate';
import { SortTypes } from '../enums/SortTypes';
import OfficeListHeaderSortLink from './OfficeListHeaderSortLink';

const OfficeListColumnHeader = ({ officeList, sort, onSortChanged }) => {
    const [reversed, setReversed] = useState(false);

    useEffect(() => {
        if (officeList) {
            if (officeList.reversed !== reversed) {
                setReversed(officeList.reversed)
            }
        } else {
            setReversed(false);
        }
    }, [officeList])

    const handleSort = (sortValue, reversed) => {
        onSortChanged(sortValue, reversed)
    }

    return (
        <div className="columns px-3">
            <div className='column is-3'>
                <OfficeListHeaderSortLink sort={sort} sortValue={SortTypes.OFFICE_ID} reversed={reversed} onSortChanged={handleSort}>
                    <HrbTranslate text='DistrictPage.OfficeList.Headers.Office' />
                </OfficeListHeaderSortLink>
            </div>
            <div className='column is-2'>
                <OfficeListHeaderSortLink sort={sort} sortValue={SortTypes.OFFICE_TYPE} reversed={reversed} onSortChanged={handleSort}>
                    <HrbTranslate text='DistrictPage.OfficeList.Headers.Ownership' />
                </OfficeListHeaderSortLink>
            </div>
            <div className='column'>
                <OfficeListHeaderSortLink sort={sort} sortValue={SortTypes.NEW} reversed={reversed} onSortChanged={handleSort}>
                    <HrbTranslate text='DistrictPage.OfficeList.Headers.New' />
                </OfficeListHeaderSortLink>
            </div>
            <div className='column'>
                <OfficeListHeaderSortLink sort={sort} sortValue={SortTypes.IN_PROGRESS} reversed={reversed} onSortChanged={handleSort}>
                    <HrbTranslate text='DistrictPage.OfficeList.Headers.InProgress' />
                </OfficeListHeaderSortLink>
            </div>
            <div className='column'>
                <OfficeListHeaderSortLink sort={sort} sortValue={SortTypes.FILED} reversed={reversed} onSortChanged={handleSort}>
                    <HrbTranslate text='DistrictPage.OfficeList.Headers.Completed' />
                </OfficeListHeaderSortLink>
            </div>
            <div className='column is-2'>
                <OfficeListHeaderSortLink sort={sort} sortValue={SortTypes.AVG_FILE_TIME_DAYS} reversed={reversed} onSortChanged={handleSort}>
                    <HrbTranslate text='DistrictPage.OfficeList.Headers.AvgCompletion' />
                </OfficeListHeaderSortLink>
            </div>
           
        </div>
    );
}

OfficeListColumnHeader.propTypes = {
    officeList: object,
    sort: string,
    onSortChanged: func.isRequired
}

export default OfficeListColumnHeader